(ns frontend.view.settings2.web-form.branding             ;; TODO: remove if not used
  (:require [common.localization :as loc]
            [common.schema.registry :as registry]
            [frontend.actions.entity :as entity-actions]
            [frontend.logging :as logging]
            [frontend.state.current-session :as session]
            [frontend.view.settings2.web-form.events :as events]
            [reagent.core :as r]
            [ui.components.alert.view :as alert]
            [ui.components.image-uploader.view :as image-uploader]
            [ui.components.radio-group.view :as radio-group]
            [ui.components.toggle.view :as toggle]
            [ui.editors.labelled-input.view :as labelled-input]))


(defn logo-selector
  [{:keys [webentry]}]
  (let [{:keys [webentry/logo]} webentry]
    [image-uploader/image-view
     {:edit?              (not logo)
      :show-title?        true
      :value              logo
      :key                :webentry/logo
      :label              (loc/tr :company-settings-webentry-logo)
      :css-class          "webentry-logo"
      :on-remove!         (fn [_]
                            (entity-actions/*->field-update!
                             (:db/id webentry)
                             :webentry/logo
                             nil
                             identity
                             identity))
      :on-change          (fn [v]
                            (events/file-logo-chosen :webentry/logo v)
                            (events/save-image! webentry))}]))

(defn background-image-selector
  [{:keys [webentry]}]
  (let [{:keys [webentry/background-image]} webentry]
    [image-uploader/image-view
     {:edit?              (not background-image)
      :show-title?        true
      :value              background-image
      :key                :webentry/background-image
      :label              (loc/tr :company-settings-webentry-background-image)
      :css-class          "webentry-background"
      :on-remove!         (fn [_]
                            (entity-actions/*->field-update!
                             (:db/id webentry)
                             :webentry/background-image
                             nil
                             identity
                             identity))
      :on-change          (fn [v]
                            (events/file-logo-chosen :webentry/background-image v)
                            (events/save-image! webentry))}]))

(defn position-selector
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/position
        old-value (get webentry attribute)
        position (or old-value :position/center)
        options (->> [:position/left :position/center :position/right]
                     (map (fn [p]
                            {:value   p
                             :content (loc/tr p)})))]
    [:div
     {:class "flex gap-6 mb-2"}
     [radio-group/radio-group-v2
      {:checked   position
       :orientation :horizontal
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Update successful!"))
                       (fn [err] ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update " err)))))}
      options]]))

(defn color-input
  [{:keys [webentry attribute entity-atom]}]
  (let [old-value (-> webentry
                      :webentry/colors
                      attribute)]
    [:div
     [labelled-input/view
      {:label (let [fs (registry/get-field-schema @session/tenant-schema
                                                  attribute)]
                (loc/field-name attribute fs))
       :data-type :data.type/text-simple
       :value     old-value
       :on-change (fn [new-value]
                    (swap! entity-atom assoc-in [:webentry/colors attribute] new-value))
       :on-blur  (fn [new-value]
                   (events/save-color!
                    webentry
                    attribute
                    new-value
                    (fn [_]
                      (logging/info "Updating color was successful!"))
                    (fn [err]
                      (logging/error "Failed to update color " err))))}]]))


(defn branding-toggle
  [{:keys [webentry]}]
  (let [attribute :webentry/branding
        _old-value (get webentry attribute)]
    [:div
     [toggle/toggle
      {:checked?     true #_(boolean old-value) ;;TODO why was this hardcoded to be always checked and disabled? Not needed or to be added later?
       :disabled? true
       :on-change  (fn [_new-value]
                     #_(when-not (= new-value old-value)
                       (swap! entity-atom assoc attribute new-value)
                       (events/save-webform!
                        webentry
                        attribute
                        new-value
                        (fn [_]
                          (logging/info "Update successful!"))
                        (fn [err] ;;retract the optimistic save above
                          (when (= new-value (get @entity-atom attribute))
                            (swap! entity-atom assoc attribute old-value))
                          (logging/error "Failed to update " err)))))}
      (loc/tr :no)
      (loc/tr :yes)]]))


(defn view
  [_]
  (let [state-atom (r/atom {})]
    (fn [{:keys [webentry entity-atom]}]
      [:div
       {:class "grid grid-cols-1 gap-4"}
       [:div
        {:class "flex flex-col gap-4"}
        [:div
         {:class "flex flex-col gap-3"}
         [:div
          {:class "font-semibold text-xl"}
          (loc/tr :web-form-settings/make-it-yours)]
         [:div
          {:class "grid grid-cols-1 lg:grid-cols-2 gap-4"}
          [:div
           [logo-selector
            {:webentry    webentry
             :entity-atom entity-atom}]]
          [:div
           [background-image-selector
            {:webentry    webentry
             :entity-atom entity-atom}]]]]
        [:div
         {:class "flex flex-col gap-3"}
         [:label
          (loc/tr :web-form-settings/position-on-page)]
         [position-selector
          {:webentry    webentry
           :state-atom  state-atom
           :entity-atom entity-atom}]]
        [:div
         [color-input
          {:webentry    webentry
           :attribute   :webentry.color/page-background
           :entity-atom entity-atom
           :state-atom  state-atom}]]
        [:div
         [color-input
          {:webentry    webentry
           :attribute   :webentry.color/form-background
           :entity-atom entity-atom
           :state-atom  state-atom}]]
        [:div
         [color-input
          {:webentry    webentry
           :attribute   :webentry.color/font
           :entity-atom entity-atom
           :state-atom  state-atom}]]
        [:div
         {:class "flex flex-col gap-2"}
         [:div
          {:class "mb-3 inline-flex items-center gap-4"}
          [branding-toggle
           {:webentry    webentry
            :entity-atom entity-atom
            :state-atom  state-atom}]
          [:label
           (loc/tr :web-form-settings/show-branding)]]
         [alert/info
          {}
          (loc/tr :web-form-settings/branding-note)]]]])))
